import { Action } from "redux-ts";
import { put, takeEvery } from "redux-saga/effects";
import {
    errorActions,
    merchCurateActions,
    opsMetricsActions,
} from "../../actions";
import {
    METRIC_KEYS,
    searchMerchPayload,
    searchMerchResponse,
} from "../../../models";
import * as services from "../../../service";
import { createSuccessOpsMetricsPayload } from "../../../utils";

export const merchSearchSagas = [watchGetSearchMerchResults()];

function* getMerchSearchResults(action: Action<searchMerchPayload>) {
    const start = Date.now();
    const functionName = "getMerchSearchResults";
    
    try {
        yield put(merchCurateActions.merchSearchInProgress(true));

        const response: searchMerchResponse =
            yield services.getMerchSearchResults(action.payload.request);

        yield put(merchCurateActions.merchSearchCompleted(response.results));
        yield put(merchCurateActions.merchSearchInProgress(false));

        yield put(
            opsMetricsActions.batchMetric(
                createSuccessOpsMetricsPayload(functionName)
            )
        );
    } catch (ex) {
        yield put(merchCurateActions.merchSearchCompleted([]));
        yield put(merchCurateActions.merchSearchInProgress(false));

        const dataPoints = new Map<string, string | undefined>([
            [METRIC_KEYS.loadTime, `${Date.now() - start} ms`],
            [METRIC_KEYS.page, action.payload.requestPath],
        ]);
        yield put(
            errorActions.handleError({
                eventName: functionName,
                exception: ex,
                dataPoints: dataPoints,
                silent: false,
            })
        );
    }
}

function* watchGetSearchMerchResults() {
    yield takeEvery(merchCurateActions.merchSearch.type, getMerchSearchResults);
}
